module.exports = __webpack_public_path__ + "files/384562be97429b1b091e068e5a591a43.png";